import http from '@/api/request'

const BASE = '/resource/api/shop/entrance/test/diagnosis'

/** 可测学科列表（默认同等学力） */
export function diagnosisSubjectList(data = {}) {
  return http().post(`${BASE}/subject/list`, data)
}

/** 目标报考院校列表（调查表用） */
export function diagnosisCollegeList(data = {}) {
  return http().post(`${BASE}/college/list`, data)
}

/** 按学科查已发布诊断方案 */
export function diagnosisEntranceView(data) {
  return http().post(`${BASE}/view`, data)
}

/** 调查表保存 */
export function diagnosisUserSave(data) {
  return http().post(`${BASE}/user/save`, data)
}

/** 诊断开考 */
export function diagnosisStartExam(data) {
  return http().post(`${BASE}/start/exam`, data)
}

/** 诊断答题保存 */
export function diagnosisAnswerSave(data) {
  return http().post(`${BASE}/answer/save`, data)
}

/** 诊断交卷 */
export function diagnosisFinishExam(data) {
  return http().post(`${BASE}/finish/exam`, data)
}

/** 查询报告生成状态（轮询用） */
export function diagnosisReportStatus(data) {
  return http().post(`${BASE}/report/status`, data)
}

/** 查询报告详情 */
export function diagnosisReportGet(data) {
  return http().post(`${BASE}/report/get`, data)
}

/** 查询报告导出权限 */
export function diagnosisReportExportAllowed(data) {
  return http().post(`${BASE}/report/export-allowed`, data)
}

/** 历史诊断报告：已登录按当前用户查；游客须验证码或有效 verifyToken */
export function diagnosisReportHistory(data = {}) {
  return http().post(`${BASE}/report/history`, data)
}
